export default "__VITE_ASSET__ba7c9d8e__"